exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-1a3966e4]{font-size:1.6em}.booking-information[data-v-1a3966e4]{padding:20px 30px 30px;padding:20px 3px 30px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1a3966e4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/infos/additional-services/Home.vue
// module id = 586
// module chunks = 0